// Shared link builder for the sewing sub-site: deep-link any primitive into
// the lab with its proportions preloaded (?shape=cylinder&radius=1.2...).
// Used by lessons, the assembly lab, composite cut lists, and the creature
// generator, so a teddy arm opens as the actual cylinder it is.

import { SHAPE_MAP } from "./sewingShapes";

export const LAB_PATH = "/sewing-primitives/lab";

// Accepts a shape id, optionally with params (e.g. a composite part's).
// Only keys that have visible sliders are carried; hidden tessellation
// params (segments, rows) stay out.
export const labHref = (shapeId, params) => {
  const shape = SHAPE_MAP[shapeId];
  const qs = new URLSearchParams({ shape: shapeId });
  if (params && shape) {
    const visible = shape.params.map((p) => p.key);
    Object.entries(params).forEach(([k, v]) => {
      if (!visible.includes(k)) return;
      qs.set(k, typeof v === "number" ? String(Math.round(v * 10) / 10) : String(v));
    });
  }
  return `${LAB_PATH}?${qs.toString()}`;
};
